import api from '@pray/shared/utils/api';

export async function updateContentSummary({ artistId = null, contentId = null, locale = null, summary = null, short_summary = null }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!locale) throw Error('Locale is required');

  const data = {};
  if (summary !== null) data.summary = summary;
  if (short_summary !== null) data.short_summary = short_summary;

  const url = `/web/studio/artists/${artistId}/content/${contentId}/locales/${locale}/summary`;
  const response = await api.executePutRequest(url, data);

  return response.data;
}
